module.exports = __webpack_public_path__ + "img/co1.f27519de.png";